import styled from 'styled-components'
import { Pagination, Image, Button, Empty, Typography, Modal } from 'antd'
import { IconFont, DeleteModal, SvgIcon, SignTitle, FilterForm, AiMailModal } from '@/components'
import {
  useGetPhishingPages,
  useDelPhishEmail,
  useGetPhishAttck,
  useCheckAvailableStatus,
  useGetEducationTemplateList,
} from './utils'
import { useGetAiPhishingPageTemplate, useCreateAiPhishingPageTemplate } from '../create/utils'
import { useDebounceFn } from 'ahooks'
import { useState } from 'react'
import { GetPhishingPages } from '@/api/template'
import { SearchInput } from '@/components/search-input'
import { EditTemplate } from './edit-template'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { AdvancedPopover, DTOption } from '@/components/advanced-search'
import { CreatePhishing } from './create-phishing'
import { Message } from '@/components/message'
import { t } from '@/i18n'
export const PhishingTemplate = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [delPhishEmail] = useDelPhishEmail()
  const [availableStatus] = useCheckAvailableStatus()
  const [getPhishingParams, setGetPhishingParams] = useState<GetPhishingPages>({
    limit: 20,
    page: 1,
    name: '',
    origin_type: 0,
    autocommit: 0,
  })
  const [visible, setVisible] = useState({ visible: false, id: null, type: null })
  const [aiVisible, setAiVisible] = useState(false)
  const [getAiPhishingPageTemplate, searchLoading] = useGetAiPhishingPageTemplate()
  const [phishingTemplateList, setPhishingTemplateList] = useState([])
  const [createAiPhishingPageTemplate, submitLoading] = useCreateAiPhishingPageTemplate()
  const [templateList, getTemplateList] = useGetEducationTemplateList()
  function close(data) {
    if (data) {
      getPhishing()
    }
    setVisible({ visible: false, id: null, type: null })
  }
  const [getPhishing, phishing] = useGetPhishingPages({ GetPhishingParams: getPhishingParams })
  const [attckList] = useGetPhishAttck()

  const { run } = useDebounceFn(
    value => {
      setGetPhishingParams(origin => ({ ...origin, page: 1, name: value }))
    },
    {
      wait: 500,
    },
  )
  const [deleteModal, setDeleteModal] = useState({ visible: false, id: null })
  const deleteEmailHandler = async () => {
    try {
      await delPhishEmail({ id: deleteModal.id })
      Message.success('删除成功')
      if (
        getPhishingParams.page > 1 &&
        (getPhishingParams.page - 1) * getPhishingParams.limit + 1 === phishing.total
      ) {
        setGetPhishingParams(origin => ({ ...origin, page: getPhishingParams.page - 1 }))
      } else {
        await getPhishing()
      }
      setDeleteModal({ visible: false, id: null })
    } catch (err) {}
  }
  const handleCancel = data => {
    if (data) {
      getPhishing()
    }
    setIsModalVisible(false)
  }
  const [visibles, setVisibles] = useState({ visible: false, cover: '' })
  const [attckVisible, setAttckVisible] = useState({ visible: false, list: [] })
  // const [attckVisible, setAttckVisible] = useState({
  //   visible: true,
  //   list: [
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络资源准备-准备基础设施-僵尸网络资源准备-准备基础设施-僵尸网络资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //     {
  //       name: '资源准备-准备基础设施-僵尸网络',
  //       url: 'https://attack.mitre.org/techniques/T1583/005',
  //     },
  //   ],
  // })

  let option = {
    name: {
      type: 'input',
      label: '模板名称',
    },
    origin_type: {
      type: 'radio',
      label: '模板类型',
      data: [
        { name: '系统内置', id: 1 },
        { name: '自定义', id: 2 },
        { name: 'AI生成', id: 3 },
      ],
    },
    autocommit: {
      type: 'radio',
      label: '钓鱼页类型',
      data: [
        { name: '钓鱼页', id: 2 },
        { name: '钓鱼页（信息收集）', id: 1 },
      ],
    },
    attck_name: {
      type: 'multiple',
      label: 'ATT&CK',
      data: attckList?.map(item => ({ name: item.name, id: item.name })),
      typeof: 'array',
    },
  }
  // const [visibleSearch, setVisibleSearch] = useState(false)
  const onFinish = values => {
    const { time, template, autocommit, attck_name } = values
    setGetPhishingParams(origin => ({
      ...origin,
      origin_type: template,
      autocommit: autocommit,
      attck_name,
      page: 1,
    }))
    // setVisibleSearch(false)
  }
  return (
    <Template>
      <div className="title-btn">
        <Button
          type="primary"
          className="ai-btn"
          style={{
            marginLeft: 16,
            width: '124px',
            height: '32px',
            background: 'linear-gradient( 174deg, #2090A8 0%, #4F4FAE 100%)',
            border: 'none',
            opacity: availableStatus?.status === 'AvailableStatusTrue' ? 1 : 0.5,
            cursor: availableStatus?.status === 'AvailableStatusTrue' ? 'pointer' : 'not-allowed',
          }}
          onClick={() => {
            if (availableStatus?.status !== 'AvailableStatusTrue') return
            setAiVisible(true)
            setPhishingTemplateList([])
          }}
        >
          <SvgIcon name="AI" width={'16px'} height={'16px'} style={{ marginRight: '8px' }} />
          {t('AI生成模板')}
        </Button>
        <Button type="primary" onClick={() => setIsModalVisible(true)}>
          {t('添加自定义模板')}
        </Button>
      </div>
      <FilterForm
        option={option}
        setSearchParams={setGetPhishingParams}
        setFilterHeight={v => {
          console.log(v)
        }}
        onReset={() => {
          setGetPhishingParams({
            page: 1,
            limit: 10,
          })
        }}
      />

      {/* <AdvancedPopover
         option={option}
         onConfirm={onFinish}
         left={
           <Button type="primary" onClick={() => setIsModalVisible(true)}>
             添加自定义模板
           </Button>
         }
         buttonLeft={
           <SearchInput
             inputProps={{
               placeholder: '模板名称',
               onChange: e => run(e.target.value),
             }}
           />
         }
        /> */}
      <AiMailModal
        visible={aiVisible}
        modalType={'4'}
        placeholder={'请输入邮件主题描述，如：五一假期礼品领取'}
        onConfirm={(values, handleSuccess) => {
          console.log('onConfirm', values)
          getTemplateList({ limit: 9999, page: 1, keyword: '' }).catch(_ => {})
          let { name, subject, sender, redirect, security_id } = values
          if (redirect) {
            if (security_id === '1') {
              security_id = redirect
              redirect = templateList?.items?.filter(e => redirect === e.id)?.[0]?.redirect
            }
            if (
              security_id === '0' &&
              !(redirect.includes('http://') || redirect.includes('https://'))
            ) {
              redirect = `https://${redirect}`
            }
          }
          const cover = '/static/default/phishPage.png'
          const content = JSON.parse(localStorage.getItem('aiEmailText'))?.content || ''
          createAiPhishingPageTemplate({
            name,
            subject,
            sender,
            content,
            cover,
            redirect,
            autoCommit: 2,
            securityId: security_id === '0' ? '0' : security_id,
          })
            .then(res => {
              setAiVisible(false)
              localStorage.removeItem('aiEmailText')
              setGetPhishingParams(origin => ({ ...origin, page: 1 }))
              handleSuccess()
            })
            .catch(_ => {})
        }}
        inputSearch={value => {
          getAiPhishingPageTemplate({
            subject: value.subject,
            message1: value.message1 ? value.message1 : '账号',
            message2: value.message2 ? value.message2 : '密码',
          })
            .then(res => {
              console.log('res111', res)
              setPhishingTemplateList(
                res.data.list.map((item, index) => ({ ...item, id: index })) || [],
              )
            })
            .catch(_ => {})
        }}
        submitLoading={submitLoading}
        searchLoading={searchLoading}
        templateList={phishingTemplateList || []}
        onCancel={() => {
          setAiVisible(false)
        }}
      />

      {isModalVisible && (
        <CreatePhishing isModalVisible={isModalVisible} handleCancel={handleCancel} />
      )}
      <EditTemplate isModalVisible={visible} handleCancel={close} />
      <Main>
        {phishing?.items?.map(item => (
          <div className="list-main" key={item?.id}>
            {item?.origin_type === 1 && <div className="hint">{t('系统内置')}</div>}
            {item?.origin_type === 2 && <div className="custom">{t('自定义')}</div>}
            {item?.origin_type === 3 && <div className="ai">{t('AI生成')}</div>}
            <div className={item?.origin_type === 1 ? 'list list1' : 'list'} key={item?.id}>
              <div className="img-main">
                {item?.origin_type === 1 && (
                  <div className="img-container">
                    <Image
                      // width={'64px'}
                      fallback={`${
                        process.env.NODE_ENV === 'dev' ? '/api' : ''
                      }/static/default/phishPage.png`}
                      src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${item?.cover}`}
                      preview={false}
                      onClick={() => {
                        setVisibles({ visible: true, cover: item?.cover })
                      }}
                    />
                  </div>
                )}
                {(item?.origin_type === 2 || item?.origin_type === 3) && item?.autocommit === 1 && (
                  <SvgIcon name={'phishing-page-information'} width={'64px'} height={'64px'} />
                )}
                {(item?.origin_type === 2 || item?.origin_type === 3) && item?.autocommit === 2 && (
                  <SvgIcon name={'phishing-page'} width={'64px'} height={'64px'} />
                )}
              </div>
              <div className="headline">
                <div className="title">
                  <Typography.Text
                    ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
                    style={{ width: 300 }}
                  >
                    {item?.name || '-'}
                  </Typography.Text>
                </div>
                <div className="text">
                  {t('重定向页面：')}
                  <a target="_blank" href={item?.redirect} rel="noopener noreferrer">
                    {item?.redirect || '-'}
                  </a>
                </div>
                <div className="text">
                  {t('邮件类型：')}
                  {item?.autocommit === 1 && (
                    <span className="accessory">{t('钓鱼页+信息收集')}</span>
                  )}
                  {item?.autocommit === 2 && <span className="link">{t('钓鱼页')}</span>}
                </div>
              </div>
            </div>
            {item?.origin_type === 1 ? (
              <div className="attck-container">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="label">ATT&CK：</div>
                  {item?.attck?.length > 1 && (
                    <div
                      className="more"
                      onClick={() => {
                        setAttckVisible({ visible: true, list: item?.attck })
                      }}
                    >
                      {t('更多')}
                    </div>
                  )}
                </div>
                <div className="content">
                  {item?.attck?.[0] ? (
                    <Typography.Text
                      ellipsis={{
                        tooltip: {
                          title: item?.attck?.[0]?.name,
                          getPopupContainer: () => document.body,
                        },
                      }}
                    >
                      {/*{item?.attck?.[0]?.name}*/}
                      <a href={item?.attck?.[0]?.url} target="_blank" rel="noopener noreferrer">
                        {item?.attck?.[0]?.name}
                      </a>
                    </Typography.Text>
                  ) : (
                    '-'
                  )}
                </div>
              </div>
            ) : (
              <div className="examine">
                {item?.origin_type === 1 && (
                  <div
                    className="operation"
                    onClick={() => {
                      setVisibles({ visible: true, cover: item?.cover })
                    }}
                  >
                    <IconFont type={'icon-chakan'} /> {t('预览')}
                  </div>
                )}
                {(item?.origin_type === 2 || item?.origin_type === 3) && (
                  <>
                    <div
                      className="operation"
                      onClick={() =>
                        setVisible({
                          visible: true,
                          id: item.id,
                          type: 2,
                          origin_type: item?.origin_type,
                        })
                      }
                    >
                      <IconFont type={'icon-bianji'} style={{ marginRight: 6 }} />
                      <span>{t('编辑')}</span>
                    </div>
                    <div
                      className="operation"
                      onClick={() => setDeleteModal({ visible: true, id: item?.id })}
                    >
                      <IconFont type={'icon-shanchu-m'} style={{ marginRight: 6 }} />
                      <span>{t('删除')}</span>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </Main>
      {!phishing?.items && <Empty image={EmptyImg} />}
      <Image
        key={visibles?.cover}
        style={{ display: 'none' }}
        preview={{
          visible: visibles.visible,
          src: `${process.env.NODE_ENV === 'dev' ? '/api' : ''}${visibles?.cover}`,
          onVisibleChange: value => {
            setVisibles({ visible: value, cover: '' })
          },
        }}
      />

      <DeleteModal
        onOk={deleteEmailHandler}
        onCancel={() => {
          setDeleteModal({ visible: false, id: null })
        }}
        visible={deleteModal.visible}
        text={'此操作将永久删除,是否继续?'}
      />

      <AttckModal
        centered
        width={560}
        visible={attckVisible.visible}
        title={<SignTitle show>ATT&CK</SignTitle>}
        footer={null}
        destroyOnClose
        // bodyStyle={{ height: 300, overflow: 'scroll' }}
        onCancel={() => {
          setAttckVisible({ visible: false, list: [] })
        }}
      >
        {attckVisible.list?.map((item, index) => (
          <div className="item" key={index}>
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              {item.name}
            </a>
          </div>
        ))}
      </AttckModal>
      {phishing?.items && (
        <div className="pageination">
          <Pagination
            onChange={(page, limit) => {
              setGetPhishingParams(origin => ({ ...origin, page, limit }))
            }}
            defaultCurrent={1}
            total={phishing?.total}
            showSizeChanger
            showQuickJumper
            current={getPhishingParams.page}
            pageSize={getPhishingParams.limit}
            defaultPageSize={20}
            pageSizeOptions={['20', '40', '60', '80', '100']}
            showTotal={totals => (
              <div>
                {t('共')}
                <a>{totals}</a>
                {t('条')}
              </div>
            )}
          />
        </div>
      )}
    </Template>
  )
}

const AttckModal = styled(Modal)`
  .item {
    width: 480px;
    //height: 32px;
    line-height: 22px;
    background: #f7f7f7;
    border-radius: 6px;
    padding: 4px 16px;
    margin-bottom: 8px;
  }
  .ant-modal-body {
    padding: 20px 36px;
    height: 300px;
    overflow: scroll;
  }
`
const Template = styled.div`
  .title-btn {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 10px;
    padding: 0 20px;
    .ant-btn.ai-btn:hover {
      width: 133px;
      height: 100%;
      background: linear-gradient(45deg, #2090a8 0%, #4f4fae 100%) !important;
    }
  }
  .pageination {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    margin-right: 20px;
  }
  .ant-popover-title {
    height: 50px;
    display: flex;
    align-items: center;
  }
  .search-button {
    background: #f1f3f8;
    border-radius: 6px;
    padding: 9px 18px;
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #0b0a27;
      background: #e2e4f6;
    }
  }
`
const Main = styled.div`
  padding: 0;
  width: 100%;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(327px, 1fr));
  grid-gap: 20px;
  padding: 0 20px;
  .list-main {
    height: 174px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    display: flex;
    position: relative;
    overflow: hidden;
    .hint {
      position: absolute;
      right: -1px;
      top: -1px;
      background: #558492;
      border-radius: 0px 8px 0px 8px;
      color: #fff;
      font-size: 14px;
      padding: 4px 6px;
    }
    .custom {
      position: absolute;
      right: -1px;
      top: -1px;
      background: #ed787e;
      border-radius: 0px 8px 0px 8px;
      color: #fff;
      font-size: 14px;
      padding: 4px 6px;
      z-index: 1;
    }
    .ai {
      background: linear-gradient(174deg, #2090a8 0%, #4f4fae 100%);
      border-radius: 0px 8px 0px 8px;
      color: #ffffff;
      padding: 4px 6px;
      font-size: 14px;
      position: absolute;
      right: -1px;
      top: -1px;
    }
  }
  .list {
    width: 100%;
    background: #ffffff;
    padding: 16px 6px 10px 12px;
    height: calc(100% - 32px);
    display: flex;
    align-items: center;
  }
  .list1 {
    height: calc(100% - 60px);
  }
  .examine {
    height: 30px;
    background: #f1f1f1;
    border-radius: 0px 0px 8px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
    width: 100%;
    .operation {
      flex: 1;
      text-align: center;
      border-left: 1px solid #d9d9d9;
      &:nth-child(1) {
        border: 0;
      }
    }
  }
  .attck-container {
    width: 100%;
    height: 60px;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 8px 12px;
    border-top: 1px dashed #eaedf1;
    .label {
      color: #666;
    }
    .more {
      cursor: pointer;
      color: #666666;
      &:hover {
        color: #4238c9;
      }
    }
    .content {
      margin-top: 4px;
      height: 24px;
      background: #f7f7f9;
      border-radius: 6px;
      padding: 0 6px;
      line-height: 24px;
    }
  }
  .headline {
    margin-left: 17px;
    width: calc(100% - 84px);
  }
  .text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    color: #666;
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.2;
  }
  .title {
    color: #333;
    font-weight: 700;
    line-height: 1.2;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .accessory {
    background: #e0f2f2;
    font-size: 13px;
    display: inline-block;
    padding: 4px 8px;
    text-align: center;
    font-size: 12px;
    color: #65bdc0;
    border-radius: 4px;
  }
  .link {
    padding: 4px 8px;
    background: #d5e4ff;
    font-size: 12px;
    display: inline-block;
    text-align: center;
    color: #2973ff;
    border-radius: 4px;
  }
  //.img-main {
  //  width: 64px;
  //  border-radius: 6px;
  //  overflow: hidden;
  //  display: flex;
  //  height: 85px;
  //  align-items: center;
  //  border: 2px solid #edeeec;
  //  background: #efeeec;
  //}
  .img-main {
    width: 70px;
    height: 94px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    overflow: hidden;
  }
  .img-container {
    width: 64px;
    height: 85px;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    //background: #eeedeb;
    transition: all 0.3s;
    border: 2px solid #edeeec;
    background: #efeeec;
    cursor: pointer;
    &:hover {
      width: 70px;
      height: 94px;
    }
  }
  .ant-image {
    width: 100%;
  }
`
